import { deleteTariffPlanType, } from "@Api/CountrySettings/countryGroup";
import Button from "@Components/Button";
import Card from "@Components/Card";
import Close from "@Components/Icons/Close";
import Loading from "@Components/Icons/Loading";
import InfoPopup from "@Components/InfoPopup";
import { ERROR, SUCCESS } from "@Components/Toast";
import Box from "@mui/material/Box";
import React from "react";
import styles from "./index.module.scss";
export default class Delete extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
        };
    }
    onConfirm = async () => {
        if (!this.props.plan?.id || this.state.isLoading) {
            return;
        }
        this.setState({ isLoading: true });
        try {
            await deleteTariffPlanType(this.props.plan.id);
            this.props.close(true);
            this.props.notify({
                status: SUCCESS,
                title: "Success",
                description: "Tariff plan type deleted successfully.",
            });
        }
        catch (error) {
            this.props.notify({
                status: ERROR,
                title: "Error",
                description: "Failed to delete tariff plan type.",
            });
            console.error("Failed to delete tariff plan type", error);
        }
        finally {
            this.setState({ isLoading: false });
        }
    };
    createPopup = (close) => {
        if (!this.props.plan) {
            return null;
        }
        return (React.createElement(Card, { className: styles.container },
            React.createElement(Box, { className: styles.header },
                React.createElement("h2", { className: styles.title }, "Delete tariff plan type"),
                React.createElement("div", { onClick: () => close(), className: styles.closeBtn },
                    React.createElement(Close, { onClick: () => close(), color: "#585C61", size: "0.75rem", className: styles.exitButton }))),
            React.createElement(Box, { className: styles.content },
                React.createElement("p", null,
                    "Deleting ",
                    React.createElement("span", null, this.props.plan.name),
                    " will also remove all its country settings. Are you sure you want to continue?")),
            React.createElement(Box, { className: styles.actions },
                React.createElement(Button, { click: () => close(), dark: true, className: styles.cancelBtn }, "CANCEL"),
                React.createElement(Button, { click: this.onConfirm, disabled: this.state.isLoading }, this.state.isLoading ? (React.createElement(Loading, { size: "1rem" })) : ("DELETE")))));
    };
    render() {
        return (React.createElement(InfoPopup, { trigger: this.props.open, content: this.createPopup, onClose: () => this.props.close() }));
    }
}
